<vw-toast-popup [isOpen]="isOpen" [title]="'calendar.frost.sheet.title' | translate" (close)="onClose()">
  @if (frostDates) {
    <div class="flex flex-col gap-4 px-4 pb-8">
      @if (city && frostDates.altitudeM != null) {
        <p class="text-body text-vw-body">{{ 'calendar.frost.sheet.where-altitude' | translate: { city: city, altitude: frostDates.altitudeM } }}</p>
      } @else if (city) {
        <p class="text-body text-vw-body">{{ 'calendar.frost.sheet.where' | translate: { city: city } }}</p>
      }
      <div class="flex flex-col divide-y divide-vw-line rounded-2xl border border-vw-line">
        @if (frostDates.lastSpringFrost) {
          <div class="flex items-start gap-3 p-3">
            <span class="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-vw-surface-tint text-title-s" aria-hidden="true">☀️</span>
            <span>
              <span class="block text-body font-semibold text-vw-ink">{{ 'calendar.frost.sheet.last' | translate: { date: day(frostDates.lastSpringFrost) } }}</span>
              @if (frostDates.lastSpringFrostSafe) {
                <span class="block text-body-s text-vw-muted">{{ 'calendar.frost.sheet.last-safe' | translate: { date: day(frostDates.lastSpringFrostSafe) } }}</span>
              }
            </span>
          </div>
        }
        @if (frostDates.firstAutumnFrost) {
          <div class="flex items-start gap-3 p-3">
            <span class="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-vw-surface-tint text-title-s" aria-hidden="true">❄️</span>
            <span>
              <span class="block text-body font-semibold text-vw-ink">{{ 'calendar.frost.sheet.first' | translate: { date: day(frostDates.firstAutumnFrost) } }}</span>
              @if (frostDates.firstAutumnFrostEarly) {
                <span class="block text-body-s text-vw-muted">{{ 'calendar.frost.sheet.first-early' | translate: { date: day(frostDates.firstAutumnFrostEarly) } }}</span>
              }
            </span>
          </div>
        }
      </div>
      <p class="text-body text-vw-body">{{ 'calendar.frost.sheet.warm-crops' | translate }}</p>
      <p class="text-body-s text-vw-muted">{{ 'calendar.frost.sheet.ground-frost' | translate }}</p>
      <!-- Sans relevé (normale du climat seule), pas de « Calculé sur 0 ans ». -->
      @if (frostDates.yearsCount) {
        <p class="text-caption text-vw-muted">{{ 'calendar.frost.sheet.source' | translate: { years: frostDates.yearsCount } }}</p>
      }
      <vw-button [label]="'calendar.frost.sheet.ok'" look="primary" customClass="w-full" (click)="onClose()"></vw-button>
    </div>
  }
</vw-toast-popup>
